<template>
  <b-modal
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @hidden="cancel"
    @ok="agree"
    static
  >
    <template v-slot:modal-header="{ cancel }">
      <h5 class="modal-title">{{title}}</h5>
      <button
        type="button"
        aria-label="Close"
        class="close"
        @click.prevent="cancel"
      >
          <span class="material-icons">
            close
          </span>
      </button>
    </template>
    <div>
      <div v-show="!!message" class="pa-5" v-html="message"></div>
    </div>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button
        variant="outline"
        class="button"
        @click.prevent="cancel"
      >
        Cancel
      </b-button>
      <b-button
        variant="primary"
        class="button"
        @click.prevent="ok"
      >
        {{ options.submitText }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>

export default {
  name: 'ConfirmModal',
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    message: null,
    title: null,
    options: {
      width: 480,
      zIndex: 99999,
      submitText: 'Submit'
    }
  }),
  methods: {
    open (title, message, options) {
      this.dialog = true
      this.title = title
      this.message = message
      this.options = Object.assign(this.options, options)
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    agree () {
      this.resolve(true)
      this.dialog = false
    },
    cancel () {
      this.resolve(false)
      this.dialog = false
    }
  }
}
</script>
